import { useMenuLookups } from "../../../../services/hooks/useMenuLookups";
import { useAppSelector } from "../../../../services/hooks/useReduxHooks";
import { CartItemType } from "../../../../services/redux/types/CartLoyaltyV2Types";
import { DISPLAYED_NAME } from "../../../../utils/enums";
import {
  getDisplayedName,
  isArabicLanguage,
  localizedNumber,
} from "../../../../utils/help/localization/localization";
import Offer from "../../../../utils/OfferClass/Offer/Offer";
import { getAddonDisplayName } from "../../../../utils/cart/menuLookup";
import { AddonGroupSubItemType } from "../../../../utils/types";
import styles from "./ItemList.module.scss";

export const AddonGroupsComponent = (props: {
  item?: CartItemType;
  offer?: Offer;
}) => {
  const { item, offer } = props;
  const isLanguageArabic = isArabicLanguage();
  const currency = useAppSelector((state) => state.config.currency);
  const { addonSubItemLookup, addonGroupLookup } = useMenuLookups();

  const subText = Offer.getLocalizedValue(offer?.uiDetails?.cartCard?.subText);

  const formatAddonName = (addonGroupSubItem: AddonGroupSubItemType) => {
    const resolvedName = getAddonDisplayName(
      addonGroupSubItem,
      addonSubItemLookup,
      addonGroupLookup
    );
    const nameSource = resolvedName
      ? {
          ...addonGroupSubItem.subItem,
          name: resolvedName,
          fullName: addonGroupSubItem.subItem?.fullName || resolvedName,
        }
      : addonGroupSubItem.subItem;

    return (
      getDisplayedName(nameSource, DISPLAYED_NAME.NAME) ||
      getDisplayedName(nameSource, DISPLAYED_NAME.FULL_NAME)
    );
  };

  const createMarkup = (html: string) => {
    return { __html: html };
  };

  const getAddonsText = (options?: { showIndividualAddonPrice: boolean }) => {
    if (item) {
      const chosenAddons: {
        addonGroupIndex: number;
        addonGroupSubItemIndex: number;
        addon: AddonGroupSubItemType;
      }[] = [];
      item.subItemDetails?.allAddonGroups?.forEach(
        (addonGroup, addonGroupIndex) =>
          addonGroup.addonGroupSubItem &&
          addonGroup.addonGroupSubItem.length > 0 &&
          addonGroup.addonGroupSubItem.forEach(
            (addonGroupSubItem, addonGroupSubItemIndex) => {
              chosenAddons.push({
                addonGroupIndex: addonGroupIndex,
                addonGroupSubItemIndex: addonGroupSubItemIndex,
                addon: addonGroupSubItem,
              });
            }
          )
      );

      return chosenAddons.map((addon, addonIndex) => {
        const addonName = formatAddonName(addon.addon);

        return (
          <span
            className={styles.add_on}
            key={`${addon.addonGroupIndex},${addon.addonGroupSubItemIndex}`}
            data-testid={`addons-${addonName}`}
          >
            {addon.addon.count &&
              addon.addon.count > 1 &&
              `(${addon.addon.count}x)`}
            {addonName}
            {options?.showIndividualAddonPrice && addon.addon.price > 0 && (
              <span className={styles.add_on__price}>
                {isLanguageArabic
                  ? ` (+${localizedNumber(addon.addon.price)} ${currency})`
                  : ` (+${currency}${localizedNumber(addon.addon.price)})`}
              </span>
            )}
            {addonIndex !== chosenAddons.length - 1 && ", "}
          </span>
        );
      });
    }

    return (
      <span
        className={styles.add_on}
        data-testid={`bundle-items`}
        dangerouslySetInnerHTML={createMarkup(
          subText ||
            Offer.getLocalizedValue(offer?.uiDetails?.cartCard?.subText) ||
            ""
        )}
      ></span>
    );
  };

  return (
    item
      ? item.subItemDetails?.allAddonGroups &&
        item.subItemDetails.allAddonGroups?.length > 0
      : !!offer
  ) ? (
    <p className={styles.add_on_container}>
      <span
        className={styles.add_on_container__addons}
        data-testid={`cart-item-addons-${
          item?.itemDetails.item_name || offer?.offerType
        }`}
      >
        {getAddonsText({ showIndividualAddonPrice: true })}
      </span>
    </p>
  ) : (
    <></>
  );
};
